import { createFileRoute } from "@tanstack/react-router";

import { getPromotionsQueryOptions } from "~/features/promotions/api";
import { PromotionsLayout } from "~/features/promotions/pages/promotion-pages";
import {
  getMenuCategoriesQueryOptions,
  getMenuDishesQueryOptions,
  getSelectedBranch,
  hasSelectedFeature,
} from "~/shared/api";

export const Route = createFileRoute("/_auth/promotions")({
  beforeLoad: async ({ context }) => {
    const branch = await getSelectedBranch(context);
    const enabled = await hasSelectedFeature(context, "promotions");
    return { promotionsBranchId: enabled ? (branch?.id ?? null) : null };
  },
  loader: ({ context: { promotionsBranchId, queryClient, trpc } }) => {
    if (!promotionsBranchId) return;
    void Promise.allSettled([
      queryClient.query({ ...getPromotionsQueryOptions({ branchId: promotionsBranchId, trpc }), staleTime: "static" }),
      queryClient.query({
        ...getMenuCategoriesQueryOptions({ branchId: promotionsBranchId, trpc }),
        staleTime: "static",
      }),
      queryClient.query({ ...getMenuDishesQueryOptions({ branchId: promotionsBranchId, trpc }), staleTime: "static" }),
    ]);
  },
  component: PromotionsLayout,
});
